import { Typography, Container } from "@mui/material";

const TermsOfService = () => {
    return (
        <Container sx={{ margin: "30px auto" }}>
            <Typography component="h1" variant="h4" align="center" mb={4}>
                Terms of Service
            </Typography>
            <Typography mb={2}>SHIPPING WAIVER & TERMS OF SERVICE</Typography>
            <Typography mb={2}>
                JHARE EXPRESS, LLC is a U.S.-based parcel forwarding company
                providing personal and business shipping services to Nigeria,
                Ghana, and South Africa. We also serve personal shoppers who
                ship items to our U.S. warehouse for reshipment at an additional
                fee.
            </Typography>

            <Typography mb={2}>
                We are an independent business and are not affiliated with any
                third party or agent. Before sending packages or working with
                anyone claiming to represent JHARE EXPRESS, LLC, you must
                contact us directly at support@jhareexpress.com or call/text
                407-922-2368 to obtain shipping authorization.
            </Typography>

            <Typography mb={2}>
                Do not send packages without our confirmation.
            </Typography>

            <Typography mb={2}>
                By shipping with us, you acknowledge and agree to the following:
            </Typography>

            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <Typography mb={2} component="li">
                    I understand that I am responsible for complying with all
                    U.S. and international shipping laws, including the Export
                    Administration Regulations (EAR), International Traffic in
                    Arms Regulations (ITAR), and sanctions enforced by OFAC.
                </Typography>

                <Typography mb={2} component="li">
                    I confirm that my shipment is not to or from an embargoed
                    country (e.g., Iran, Syria, Cuba, North Korea) and that I am
                    not on any U.S. government restricted or denied party list.
                </Typography>

                <Typography mb={2} component="li">
                    I understand that JHARE EXPRESS, LLC provides its services
                    “as is”, with no warranties or guarantees, and that I am
                    encouraged to insure any valuable packages.
                </Typography>

                <Typography mb={2} component="li">
                    I acknowledge that JHARE EXPRESS, LLC may open, inspect,
                    refuse, or return any package if it appears suspicious or in
                    violation of the law. The maximum liability per shipment is
                    $250, unless additional insurance is purchased.
                </Typography>

                <Typography mb={2} component="li">
                    I agree to include a completed and signed Shipping Form with
                    a return address in every package I send. Packages without a
                    proper form will be held for 2 business days and returned at
                    my expense. If a return label is not provided within this
                    time, the package will be refused (RTS) with no new tracking
                    number issued.
                </Typography>

                <Typography mb={2} component="li">
                    I agree that these terms represent the entire agreement
                    between myself and JHARE EXPRESS, LLC. Any updates must be
                    made in writing by the company.
                </Typography>
            </ul>
        </Container>
    );
};

export default TermsOfService;
